import React from 'react';
import PropTypes from 'prop-types';
import IntegrationCard from '../../../js/react-components/IntegrationCard';

function IntegrationContainer({
    integrationInfo = [],
    connectIntegration = () => {},
    disconnectIntegration = () => {},
    upgradeIntegration = () => {},
}) {
    const toArray = Object.values(integrationInfo);
    const group = toArray.length > 0 && toArray.map((integration, i) => (
        <IntegrationCard
            key={i}
            integrationInfo={integration}
            connectIntegration={connectIntegration}
            disconnectIntegration={disconnectIntegration}
            upgradeIntegration={upgradeIntegration}
        />
    ));
    return (
        <>
            {group}
        </>
    );
}

IntegrationContainer.propTypes = {
    integrationInfo: PropTypes.object.isRequired,
    connectIntegration: PropTypes.func.isRequired,
    disconnectIntegration: PropTypes.func.isRequired,
    upgradeIntegration: PropTypes.func.isRequired,
};

export default IntegrationContainer;
